export const getLocationFromPageCode = (pageCode) => {
  if (!pageCode) return 'HQ';

  // pageCode 끝부분에서 location 추출
  if (pageCode.endsWith('HQ')) return 'HQ';
  if (pageCode.endsWith('YT')) return 'YT';

  if (pageCode.includes('_')) {
    const parts = pageCode.split('_');
    const prefix = parts[0]; 
    if (prefix.includes('연태')) return 'YT';
    if (prefix.includes('본사')) return 'HQ';
  }

  return 'HQ'; // default
};

export const getLocationFromTab = (activeTab) => {
  return getLocationFromPageCode(activeTab);
};

/**
 * pageCode에서 기본 페이지 코드를 추출합니다 (location 제거).
 * 예: ProductManageHQ → ProductManage, ProductManageYT → ProductManage
 */
export const getBasePageCode = (pageCode) => {
  if (!pageCode) return pageCode;

  // 새로운 형식: {BasePage}{LocationCode}
  if (pageCode.endsWith('HQ')) {
    return pageCode.slice(0, -2);
  }
  if (pageCode.endsWith('YT')) {
    return pageCode.slice(0, -2);
  }

  if (pageCode.includes('_')) {
    const parts = pageCode.split('_');
    return parts[parts.length - 1];
  }

  return pageCode;
};

/**
 * location 코드를 한국어 표시명으로 변환합니다.
 */
export const getLocationDisplayName = (locationCode) => {
  const LOCATION_NAMES = {
    'HQ': '본사',
    'YT': '연태'
  };
  return LOCATION_NAMES[locationCode] || null;
};

/**
 * activeTab에서 한국어 표시명을 가져옵니다.
 */
export const getLocationDisplayNameFromTab = (activeTab) => {
  const locationCode = getLocationFromPageCode(activeTab);
  return getLocationDisplayName(locationCode);
};

export const getLocationFromState = (tabState) => {
  return getLocationFromTab(tabState?.activeTab);
};